<template>
  <span
    class="ant-calendar-picker period-date-select"
    :style="{ width: width + 'px', ...styleObj }"
  >
    <span class="ant-calendar-picker-input ant-input">
      <input
        class="ant-calendar-range-picker-input"
        type="text"
        :disabled="disabled"
        :value="select[0] > 0 ? `${select[0]}年${select[1]}期` : ''"
        :placeholder="placeholder ? placeholder[0] : ''"
      />
      <span v-if="options.range" class="ant-calendar-range-picker-separator">
        ~
      </span>
      <input
        v-if="options.range"
        class="ant-calendar-range-picker-input"
        type="text"
        :disabled="disabled"
        :value="select[2] > 0 ? `${select[2]}年${select[3]}期` : ''"
        :placeholder="placeholder ? placeholder[1] : ''"
      />

      <!-- <a-icon
        v-if="select && select.length"
        class="ant-calendar-picker-clear"
        type="close-circle"
        @click="onClear"
      ></a-icon> -->
      <sass-icon v-if="select && select.length" type="hi-kuaisuqingchu" class="ant-calendar-picker-clear" @click="onClear"/>
      <i class="anticon anticon-calendar ant-calendar-picker-icon">
        <slot name="icon">
          <a-icon type="calendar" />
        </slot>
      </i>
      <!-- 遮盖住输入框 -->
      <div class="input-mask" @click="onShow()"></div>
    </span>

    <div v-if="open" class="ant-calendar-panel" :style="{ zIndex }">
      <div class="ant-calendar-header">
        <div class="header-left">
          <a
            role="button"
            title="上个年"
            class="ant-calendar-prev-year-btn"
            @click="prev()"
          ></a>
          <span class="ant-calendar-ym-select">
            <a role="button" title="选择年份" class="ant-calendar-year-select">
              {{ year }}年
            </a>
          </span>

          <a
            v-if="!options.range"
            title="下个年"
            class="ant-calendar-next-year-btn"
            @click="next()"
          >
          </a>
        </div>

        <div v-if="options.range" class="header-right">
          <span class="ant-calendar-ym-select">
            <a role="button" title="选择年份" class="ant-calendar-year-select">
              {{ year + 1 }}年
            </a>
          </span>
          <a title="下个年" class="ant-calendar-next-year-btn" @click="next()">
          </a>
        </div>
      </div>
      <div class="ant-calendar-date-panel">
        <div class="ant-calendar-range-part ant-calendar-range-left">
          <div style="outline: none">
            <div class="ant-calendar-body">
              <table cellspacing="0" role="grid" class="ant-calendar-table">
                <tbody class="ant-calendar-tbody">
                  <tr v-for="i in 3" :key="i" role="row">
                    <td
                      v-for="j in 4"
                      :key="j"
                      :class="{
                        'ant-calendar-selected-day': selected(
                          year,
                          (i - 1) * 4 + j
                        ),
                        'ant-calendar-disabled-cell': disabled(
                          year,
                          (i - 1) * 4 + j
                        ),
                        'ant-calendar-selected-inner': selectedInner(
                          year,
                          (i - 1) * 4 + j
                        )
                      }"
                      @click="onDate(year, (i - 1) * 4 + j)"
                    >
                      <div class="ant-calendar-date">
                        {{ (i - 1) * 4 + j }}期
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div
          v-if="options.range"
          class="ant-calendar-range-part ant-calendar-range-right"
        >
          <div style="outline: none">
            <div class="ant-calendar-body">
              <table cellspacing="0" class="ant-calendar-table">
                <tbody class="ant-calendar-tbody">
                  <tr v-for="i in 3" :key="i" role="row">
                    <td
                      v-for="j in 4"
                      :key="j"
                      :class="{
                        'ant-calendar-selected-day': selected(
                          year + 1,
                          (i - 1) * 4 + j
                        ),
                        'ant-calendar-disabled-cell': disabled(
                          year + 1,
                          (i - 1) * 4 + j
                        ),
                        'ant-calendar-selected-inner': selectedInner(
                          year + 1,
                          (i - 1) * 4 + j
                        )
                      }"
                      @click="onDate(year + 1, (i - 1) * 4 + j)"
                    >
                      <div class="ant-calendar-date">
                        {{ (i - 1) * 4 + j }}期
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="open" class="mask" @click="open=false;"></div>
  </span>
</template>

<script>
/* eslint-disable eqeqeq */
// 获取最大的zindex
function getMaxZIndex() {
  return [...document.all].reduce((r, e) => Math.max(r, +window.getComputedStyle(e).zIndex || 0), 0)
}
export default {
  name: 'PeriodDateSelect',
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    // disabled: {
    //   type: Boolean,
    //   default: false,
    // },
    placeholder: {
      type: Array,
      default() {
        return ['开始月份', '结束月份']
      }
    },
    styleObj: {
      type: Object,
      default() {
        return {}
      }
    },
    width: {
      type: Number,
      default: 300
    },
    // 附加配置项
    /**
     * range: true:范围选择,false:单个选取
     * start: 可选范围开始日期 时间对象 或者 时间字符串 或者 时间戳（ms）
     * stop: 可选范围结束值 时间对象 或者 时间字符串 或者 时间戳（ms）
     * */
    options: {
      type: Object,
      default() {
        return {
          range: false,
          start: 0,
          stop: 0
        }
      }
    }
  },
  data() {
    return {
      open: false,
      zIndex: 2000,
      year: 0,
      // 被选中
      // [年,月,年,月]
      select: [0, 0, 0, 0],
      // 可选范围 [年，月，年，月]
      range: [0, 0, 0, 0]
    }
  },
  watch: {
    value: {
      handler (val) {
        if (val && val.length > 2) {
          this.select = [...val]
        } else if (val && val.length === 0) {
          this.select = [0, 0, 0, 0]
        }
      },
      deep: true
    },
    options: {
      handler(val) {
        // 计算可选范围
        if (val.start && val.stop) {
          const start = new Date(val.start)
          const stop = new Date(val.stop)
          this.range = [
            start.getFullYear(),
            start.getMonth() + 1,
            stop.getFullYear(),
            stop.getMonth() + 1
          ]
        } else {
          this.range = []
        }
      },
      deep: true
    }
  },
  methods: {
    onShow() {
      this.zIndex = getMaxZIndex() + 1
      this.open = true
    },
    onHidden() {
      this.open = false
      this.$emit('input', [...this.select])
      this.$emit('change', [...this.select])
    },
    onClear() {
      this.select = [0, 0, 0, 0]
      // 清空触发改变
      this.$emit('input', [...this.select])
      this.$emit('change', [...this.select])
    },
    prev() {
      --this.year
    },
    next() {
      ++this.year
    },
    onDate(y, d) {
      // 禁用不能选择
      if (this.disabled(y, d)) return
      // 如果是单选的话
      if (!this.options.range) {
        this.select[0] = y
        this.select[1] = d
        this.onHidden()
        this.select = [...this.select]
        return
      }
      const start = `${this.select[0]}-${this.select[1]}`
      const end = `${this.select[2]}-${this.select[3]}`
      if (start == `${y}-${d}` && end != '0-0') {
        this.select[2] = 0
        this.select[3] = 0
      } else if (end == `${y}-${d}` && start != '0-0') {
        this.select[0] = 0
        this.select[1] = 0
      } else if (start == `${y}-${d}` && end === '0-0') {
      // 第一组 选中相同且没有第二组
        this.select[2] = y
        this.select[3] = d
      } else if (end == `${y}-${d}` && start === '0-0') {
        this.select[0] = y
        this.select[1] = d
      } else if (start == `${y}-${d}` && end == `${y}-${d}`) {
        // 第一组 选中相同且第二组也相同
        this.select[0] = 0
        this.select[1] = 0
        this.select[2] = 0
        this.select[3] = 0
      } else if (start == `${y}-${d}`) {
        this.select[0] = 0
        this.select[1] = 0
      } else if (end == `${y}-${d}`) {
        // 第二组 选中相同
        this.select[2] = 0
        this.select[3] = 0
      } else if (start == '0-0') {
        // 第一组为空
        this.select[0] = y
        this.select[1] = d
      } else if (end == '0-0') {
        // 第二组为空
        this.select[2] = y
        this.select[3] = d
      } else {
        // 如果已经有，则清空另一个
        this.select[0] = y
        this.select[1] = d
        this.select[2] = 0
        this.select[3] = 0
      }

      // 两组填满后，判断是否需要交换
      if (
        this.select[2] > 0 &&
        this.select[0] >= this.select[2] &&
        this.select[1] > this.select[3]
      ) {
        const arr = [...this.select]
        this.select = [arr[2], arr[3], arr[0], arr[1]]
      } else if (
        this.select[2] > 0 &&
        this.select[0] > this.select[2]
      ) {
        const arr = [...this.select]
        this.select = [arr[2], arr[3], arr[0], arr[1]]
      }

      this.select = [...this.select]
      // 2组填满 关闭弹窗
      if (this.select[0] > 0 && this.select[2] > 0) {
        this.onHidden()
      }
    },
    // 是否选中
    selected(y, d) {
      return (
        (y == this.select[0] && d == this.select[1]) ||
        (y == this.select[2] && d == this.select[3])
      )
    },
    // 是否禁用
    disabled(y, d) {
      if (this.range[0] == 0) return
      const date = y * 100 + d
      const start = this.range[0] * 100 + this.range[1]
      const stop = this.range[2] * 100 + this.range[3]
      return date < start || date > stop
    },
    // 是否选中区间中
    selectedInner(y, d) {
      if (this.select && this.select.length === 4 && this.select[0] !== 0 && this.select[2] !== 0) {
        const date = y * 100 + d
        const start = this.select[0] * 100 + this.select[1]
        const stop = this.select[2] * 100 + this.select[3]
        return date > start && date < stop
      }
      return false
    }
  },
  created() {
    const now = new Date()
    this.year = now.getFullYear()
    if (this.options && this.options.start && this.options.stop) {
      const start = new Date(this.options.start)
      const stop = new Date(this.options.stop)
      this.range = [
        start.getFullYear(),
        start.getMonth() + 1,
        stop.getFullYear(),
        stop.getMonth() + 1
      ]
    }
  }
}
</script>

<style lang="less">
.period-date-select {
  display: inline-block;
  position: relative;
  .ant-calendar-range-picker-separator {
    margin-right: 12px;
  }
  .ant-calendar-range-picker-input {
    width: calc(44% - 6px);
    font-size: 12px;
    text-align: left;
  }
  .ant-calendar-panel {
    position: absolute;
    top: 30px;
    background-color: #fff;
    border: 1px solid #e4e7ed;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 10%);
    border-radius: 4px;
    .ant-calendar-date {
      font-size: 12px;
      width: 40px;
      height: 35px;
      line-height: 35px;
      margin: 2px 5px;
    }
    .ant-calendar-selected-day {
      .ant-calendar-date {
        color: #ffffff;
        background: #00a497;
        border: 1px solid transparent;
      }
    }
    .ant-calendar-selected-inner {
      .ant-calendar-date {
        background: #cce3dd;
      }
    }
    .ant-calendar-header {
      display: flex;
      widows: 100%;
      .header-left {
        flex: 1;
      }
      .header-right {
        flex: 1;
      }
    }
    .ant-calendar-date-panel {
      display: flex;
    }
  }
  .ant-calendar-picker-input {
    .input-mask {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 30px;
      cursor: pointer;
    }
    .ant-calendar-picker-clear {
      border: 0;
      width: 20px!important;
      right: 4px;
      top: 13px;
      color: rgba(51, 51, 51, 0.35);
      font-size: 16px;
    }
  }
  .mask{
    position: fixed;
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
  }
}
</style>
